export type MapLayerKey = 'id' | 'name' | 'mapServiceId';

export type MapLayer = {
  id: string;
  name: string;
  maxX: number;
  maxY: number;
  minX: number;
  minY: number;
  mapServiceId: string;
  changedFields?: string[];
  folder?: boolean;
  layer01GroupId?: string;
  type: LayerTypes;
  defaultOpen?: boolean;
  isHidden?: boolean;
  color?: string;
};

export type LayerField = {
  id?: string;
  locked?: boolean;
  recordStatus?: string;
  fieldName: string;
  fieldAlias: string;
  displayWithAttributes: string;
  displayWithMapTips: string;
  fieldType: string;
  layerId: string;
  timeLineAxis: string;
  formatterId: string;
  indexed: boolean;
  translations: FieldValueTranslation[];
}

export type LayerParams = {
  id: string;
};

export type Metadata = {
  id?: string;
  locked?: boolean;
  recordStatus: string;
  layerId: string;
  title: string;
  abstractText: string;
  origin: string;
  publishDate?: string;
};

export type Bounds = {
  east?: number;
  north?: number;
  south?: number;
  west?: number;
};

export type FilteredLayer = {
  id: string;
  sharedId: string;
  name: string;
  type: string;
};

export type ChildLayer = {
  name: string;
  childLayerId: string;
  parentLayerId: string;
};

export type ParentLayer = ChildLayer;

export type LayerTree = {
  layer: MapLayer;
  children: ChildLayer[];
  parents: ParentLayer[];
};

export type FieldValueTranslation = {
  lang: string;
  value: string;
};

export enum LayerTypes {
  AGS_LAYER = 'AGS_LAYER',
  CAMS_POINT_LAYER = 'CAMS_POINT_LAYER',
  COMMERCIAL_BASEMAP = 'COMMERCIAL_BASEMAP',
  HP_POINT_LAYER = 'HP_POINT_LAYER',
  KML_LAYER = 'KML_LAYER',
  SOCIAL_POINT_LAYER = 'SOCIAL_POINT_LAYER',
  VIRTUAL_LAYER = 'VIRTUAL_LAYER',
  WEATHER_MODEL_LAYER = 'WEATHER_MODEL_LAYER',
  FOLDER = 'FOLDER',
  WFS_LINE_LAYER = 'WFS_LINE_LAYER',
  WFS_POINT_LAYER = 'WFS_POINT_LAYER',
  WFS_POLYGON_LAYER = 'WFS_POLYGON_LAYER',
  WMS_LINE_LAYER = 'WMS_LINE_LAYER',
  WMS_POINT_LAYER = 'WMS_POINT_LAYER',
  WMS_POLYGON_LAYER = 'WMS_POLYGON_LAYER',
  WMS_RASTER_LAYER = 'WMS_RASTER_LAYER',
  WMTS_TILE_LAYER = 'WMTS_TILE_LAYER',
}

export type LayerExport = {
  layer: MapLayer;
};
